<template>
  <!-- 细线描边点赞，风格对齐 Element Plus / Feather 类 outline 图标 -->
  <svg
    class="xpz-svg-icon"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path
      d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"
    />
  </svg>
</template>

<script>
export default {
  name: "IconLike",
};
</script>

<style scoped>
.xpz-svg-icon {
  display: block;
  width: 1em;
  height: 1em;
}
</style>
